<!-- This is the public page anyone can see to view a user's company/onboarding info -->

<template>
  <div class="uk-container uk-margin">
    <h2>Profile Page</h2>
    <div v-if="loading">
      <p>Loading</p>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';

export default defineComponent({
  data() {
    return {
      user: {} as any,
      loading: false,
    };
  },
  methods: {
  },
  apollo: {
    user: {
      query: null, // TODO
      result(result) {
        const vm = (this as any);
        vm.loading = false;
      },
      error(error) {
        console.error(error);
      },
    },
  },
});
</script>

<style>
</style>
